/**
 * created by xcc
 * 阵地安全管理查看详情
 *
 */
import React from 'react';
import Detail from "./detail";
import {
    getContributeBatchConfig,
    getContributeDetailBottomBtn,
    getContributeDetailListBtn,
} from "../safetyManageConfig";

export default class DangerDisposeDetail extends Detail {

    renderPmsDetailListButton(record) {
        return getContributeDetailListBtn.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    renderPmsDetailBottomButton(record) {
        return getContributeDetailBottomBtn.map((item, index) => {
            return this.renderButton(record, item)
        })
    }

    getBatchConfig = () => {
        return null;
        // return getContributeBatchConfig(this.state.detailData?.disposeStatus);
    }
}